import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
// import profesorRoutes from "./profesor/index";
import ActivityRoutes from "./activity/index";
import TaskRoutes from "./task/index";
import ClassStudent from "./lesson/index";
import EvaluationsRoutes from "./evaluations/index";
import PageNotFound from "@/views/404/404.vue";
import DisconectView from "@/views/errors/DisconectView.vue";
import HomePage from "@/views/HomePage.vue"

import Store from "../store/index";

// Functions

function auth(to: any, from: any, next: any) {
    Store.dispatch('actionGetUser')
        .then((response) => {
            if (response) {
                next({ name: 'Disconect'})
            } else {
                next()
            }
        })
        .catch((error) => {
            next({ name: 'Disconect'})
            console.log(error);
        })
}


Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    ...ActivityRoutes,
    ...ClassStudent,
    ...TaskRoutes,
    ...EvaluationsRoutes,
    {   path: "/", 
        component: HomePage,
        beforeEnter: auth
    },
    { 
        path: "*", 
        component: PageNotFound,
        meta:{
            requiresAuth: true
        }, 
    },
    {
        path: "/desconectado",
        name: "Disconect",
        component: DisconectView
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

// Guard Route
router.beforeEach((to, from, next) => {
    if( to.matched.some(route => route.meta.requiresAuth)) {

        console.log("### SECURITY MIDDLEWARE ###")

        if(Store.getters.getIsLogged) {
            const user = Store.getters.getUserData;
            to.meta.roles.map(
                (item:any) => {
                    return user.roles.includes(item) ? next() : false;
                }
            )
        } else {
            console.log(Store.getters.getUserData);
            next({ name: 'Disconect'})
        }

    } else {
        next();
    }
})

export default router;
